var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.isLoading)?_c('Loading'):[_c('div',{staticClass:"card-image"},[_c('figure',{staticClass:"image is-5by3",style:({ backgroundImage: `url(${_vm.src})` })},[_vm._t("image-content")],2)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }